import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';

import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        display: 'flex',
        zIndex: 1300,
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    button: {
        width: '45px',
        height: '45px',
    },
    rightIcon: {
        marginLeft: theme.spacing(),
    },
});

class FabDropdownMenu extends React.Component {
    state = {
        open: false,
    };

    handleToggle = () => {
        this.setState(state => ({ open: !state.open }));
    };

    handleClose = event => {
        this.setState({ open: false });
    };

    render() {
        const { classes, menuItems } = this.props;
        const { open } = this.state;

        // https://material-ui.com/guides/composition/#caveat-with-refs
        const MenuBody = React.forwardRef(({ children }, ref) => (
            <div ref={ref}>{children}</div>
        ));

        return (
            <div className={classes.root}>
                <Fab
                    color="secondary"
                    aria-label="Add"
                    ref={node => {
                        this.anchorEl = node;
                    }}
                    onClick={this.handleToggle}
                    className={classes.button}
                >
                    <AddIcon />
                </Fab>
                {menuItems && (
                    <Popper
                        open={open}
                        anchorEl={this.anchorEl}
                        transition
                        disablePortal
                        style={{
                            zIndex: 1,
                        }}
                    >
                        {({ TransitionProps, placement }) => (
                            <Grow
                                {...TransitionProps}
                                style={{
                                    transformOrigin: 'center bottom',
                                }}
                            >
                                <Paper>
                                    <ClickAwayListener
                                        onClickAway={this.handleClose}
                                    >
                                        <MenuBody>
                                            {menuItems(this.handleClose)}
                                        </MenuBody>
                                    </ClickAwayListener>
                                </Paper>
                            </Grow>
                        )}
                    </Popper>
                )}
            </div>
        );
    }
}
export default withStyles(styles)(FabDropdownMenu);
